import React, { useEffect, useState } from 'react';
import { FireIcon, ClockIcon } from './Icons';
export function UrgencyBar() {
  const [seconds, setSeconds] = useState(59 * 60 + 59); // 59:59
  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  const display = `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  return <div className="w-full bg-gold py-2 px-3 md:px-6 flex items-center justify-between" data-id="element-302">
      <div className="flex-1" data-id="element-303" />
      <div className="flex flex-col items-center text-primary font-inter text-center" data-id="element-304">
        <div className="flex items-center gap-1.5 font-bold text-[11px] md:text-[13px]" data-id="element-305">
          <FireIcon className="w-3.5 h-3.5 md:w-4 md:h-4 flex-shrink-0" data-id="element-306" />
          <span data-id="element-307">Precio de lanzamiento: 83% de descuento</span>
        </div>
        <span className="text-[10px] md:text-[12px] font-semibold opacity-80" data-id="element-308">
          Solo por tiempo limitado
        </span>
      </div>
      <div className="flex-1 flex justify-end" data-id="element-309">
        <div className="flex items-center gap-1.5 text-primary font-inter font-bold text-[11px] md:text-[13px]" data-id="element-310">
          <ClockIcon className="w-3.5 h-3.5 md:w-4 md:h-4 flex-shrink-0" data-id="element-311" />
          <span data-id="element-312">{display}</span>
        </div>
      </div>
    </div>;
}